import SectionHeading from "./SectionHeading";
import { guideSteps } from "@/mocks/critter";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Field Manual"
          title="反套路指南 · 六步自检"
          desc="不教你怎么投资，只教你怎么避开坑。下单、签约、入群前，先过一遍这六条。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {guideSteps.map((g, i) => (
            <div
              key={g.title}
              className="group relative overflow-hidden rounded-lg border border-background-300 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="font-label absolute right-4 top-4 text-4xl font-bold text-background-200 group-hover:text-background-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.body}</p>
            </div>
          ))}
        </div>

        {/* bottom highlight */}
        <div className="mt-8 flex flex-col items-start justify-between gap-5 rounded-lg border border-accent-300 bg-accent-100/70 p-6 md:flex-row md:items-center md:p-7">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-800">黄金三底线</p>
            <h3 className="mt-2 font-heading text-xl font-black text-accent-950 md:text-2xl">
              遇到这三句话，请立刻收手
            </h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-700">
              『稳赚不赔』『限量稀缺』『不让查证』——满足其中任意一条，都在告诉你：这很可能不是机会，而是局。
            </p>
          </div>
          <a
            href="#about"
            className="inline-flex shrink-0 items-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}